<label class="checkbox">
  <input
    type="checkbox"
    [value]="id"
    (click)="onCheckboxChecked(id)"
    [checked]="isEntitySelected(id)"
    [disabled]="disabled"
    data-e2e="input-search-checkbox"
    tabindex="0"
  />
  <span
    *ngIf="searchedText"
    innerHTML="{{ shouldRemoveUnderscore ? (text | removeUnderscore | highlight : searchedText) : (text | highlight : searchedText)}}"
  ></span>
  <span *ngIf="!searchedText"> {{ shouldRemoveUnderscore ? (text | removeUnderscore) : text }} </span>
</label>
